export const environment = {
  production: false,
  api_url: 'https://api-test.recallme.it/api',
  appDeeplinkUrl: 'testrecallme://',
  lifetime_price_id: 'price_1QuBW1LPKNmrLus6YXptsQAk',
  lifetime_slug: 'tier-1-yearly',
  lifetime_price: 11.99,
  reduced_price_id: 'price_1RaJdzLPKNmrLus6mva83Cqa',
  reduced_slug: 'tier-1-yearly-reduced',
  reduced_price: 11.99,
  premium_price_id: 'price_1RQN4oLPKNmrLus6nshVHqRt',
  premium_slug: 'tier-1-yearly-plan',
  premium_price: 14.99,
  premium_members: 1,
  duo_price_id: 'price_1RxbkNLPKNmrLus6DhImYamY',
  duo_slug: 'duo-plan',
  duo_price: 19.99,
  duo_members: 2,
  family_price_id: 'price_1RxbldLPKNmrLus68yf694vQ',
  family_slug: 'family-plan',
  family_price: 39.99,
  family_members: 5,
  over70_price_id: 'price_1S4qV6LPKNmrLus62eZuxyUv',
  over70_slug: 'over-70',
  over70_price: 9.99,
  over70_members: 1,
  trial_days: 14,
  lifetime_valid: '2025-06-15T22:00:00.000Z', // ISO 8601 format for date
  reduced_valid: '2025-08-31T22:00:00.000Z', // ISO 8601 format for date
  iosAppStoreUrl: 'https://apps.apple.com/app/recall/id6742329792',
  androidPlayStoreUrl: 'https://play.google.com/store/apps/details?id=it.recallme.recall',
  newPlansReleaseDate: '2025-09-04T22:00:00.000Z', // ISO 8601 format for date
  gracePeriodDays: 7,
  promotionStartDate: '2025-11-21T15:42:00.000Z', // ISO 8601 format for date - active immediately in staging
  promotionEndDate: '2025-11-30T22:59:59.999Z', // ISO 8601 format for date - active until far future in staging
  // Gift cards Stripe price IDs
  gift_card_individual_price_id: 'price_1SDXxOLPKNmrLus6cUQPqwBG',
  gift_card_individual_price: 14.99,
  gift_card_duo_price_id: 'price_1SDXxlLPKNmrLus6GLeto377',
  gift_card_duo_price: 19.99,
  gift_card_family_price_id: 'price_1SDXy7LPKNmrLus6h5aXqJUe',
  gift_card_family_price: 39.99,
  // Public gift card URLs
  gift_card_individual_url: 'https://buy.stripe.com/test_dRm5kE88l7GG1hT6TDgUM03',
  gift_card_duo_url: 'https://buy.stripe.com/test_dRm5kE88l7GG1hT6TDgUM03',
  gift_card_family_url: 'https://buy.stripe.com/test_dRm5kE88l7GG1hT6TDgUM03',
};